import { bbox } from '../assets/lac-areas.json';

export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

export const MAPBOX_BASE_STYLE = `mapbox://styles/latimes/ckkktjs0f30ug17rxc9lw0ojx${
  process.env.NODE_ENV === 'development' ? '/draft' : ''
}`;

export const ACTUAL_LA_COUNTY_BOUNDS = bbox;

export const INITIAL_LA_COUNTY_BOUNDS = [
  -118.94463111489618,
  33.7036765999509,
  -117.64637477037797,
  34.82330596,
];

export const LA_COUNTY_AREAS_GEOJSON = new URL(
  '../assets/lac-areas.json',
  import.meta.url
).toString();
